<template>
  <q-card
    :data-cy="DATA_CY.NO_PLAN_BANNER"
    class="flex flex-col justify-center align-center tablet:p-4"
  >
    <q-card-section class="flex justify-center">
      <slot name="icon">
        <q-icon name="difference" color="tertiary" size="60px" />
      </slot>
    </q-card-section>
    <q-card-section class="flex flex-col text-center justify-center">
      <slot name="message">
        <div class="text-babody">
          {{ message }}
        </div>
      </slot>
    </q-card-section>
    <q-card-section>
      <slot name="action" />
    </q-card-section>
  </q-card>
</template>

<script lang="ts" setup>
import { DATA_CY } from '~/constants/strings'
withDefaults(
  defineProps<{
    message?: string
  }>(),
  {
    message: 'You currently do not have any plans published.',
  }
)
</script>
